import { render, staticRenderFns } from "./CustomerDocumentCreate.vue?vue&type=template&id=2eea329f&"
import script from "./CustomerDocumentCreate.vue?vue&type=script&lang=js&"
export * from "./CustomerDocumentCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports